<main class="atw-container hero-main">
  <section
    class="hero-grid hero-loader-host"
    [class.hero-is-loading]="heroLoading"
    [class.is-rtl]="currentLanguage === 'ar'"
    [attr.dir]="currentLanguage === 'ar' ? 'rtl' : 'ltr'"
    [attr.aria-busy]="heroLoading"
  >
    <span class="hero-orb hero-orb-1"></span>
    <span class="hero-orb hero-orb-2"></span>
    <span class="hero-grid-pattern"></span>

    <div class="hero-section-loader" *ngIf="heroLoading">
      <div class="hero-loader-card">
        <span class="hero-loader-spinner"></span>

        <strong>
          {{
            currentLanguage === 'en'
              ? 'Preparing experience...'
              : 'جاري تجهيز التجربة...'
          }}
        </strong>

        <small>
          {{
            currentLanguage === 'en'
              ? 'Loading video and content'
              : 'تحميل الفيديو والمحتوى'
          }}
        </small>
      </div>
    </div>

    <!-- Left Content -->
    <div class="hero-content hero-content-card">
      <div class="hero-badge">
        <span>{{ 'atw.hero.badgeNumber' | transloco }}</span>
        {{ 'atw.hero.badgeTitle' | transloco }}
      </div>

      <div class="hero-title-wrap">
<h1 class="typewriter-title" [attr.aria-label]="fullHeroTitle">
  <!-- Ghost title: بيحجز مساحة العنوان كاملة من الأول -->
  <span class="hero-title-ghost" aria-hidden="true">
    <span>{{ 'atw.hero.titleLine1' | transloco }}</span>
    <br />
    <strong>{{ 'atw.hero.titleStrong' | transloco }}</strong>
    <span>{{ 'atw.hero.titleLine2' | transloco }}</span>
  </span>

  <!-- Live title: ده اللي بيتكتب فوق المساحة المحجوزة -->
  <span class="hero-title-live" aria-hidden="true">
    <span>{{ typedTitleLine1 }}</span>
    <br />
    <strong>{{ typedTitleStrong }}</strong>
    <span>{{ typedTitleLine2 }}</span>
    <span class="typing-cursor" *ngIf="!typewriterDone"></span>
  </span>
</h1>
      </div>

      <p class="hero-description">
        {{ 'atw.hero.description' | transloco }}
      </p>

      <div class="hero-actions">
        <button type="button" class="primary-action" routerLink="/smartapply">
          {{ 'atw.hero.uploadCv' | transloco }}
        </button>

        <button type="button" class="secondary-action" routerLink="/jobs">
          {{ 'header.browsejobs' | transloco }}
          <img class="img-m" src="assets/as/4.webp" alt="" />
        </button>
      </div>

      <div class="hero-trust-strip">
        <div class="hero-trust-item">
          <b>{{ currentLanguage === 'en' ? 'Smart' : 'ذكي' }}</b>
          <span>{{ currentLanguage === 'en' ? 'Matching' : 'مطابقة' }}</span>
        </div>

        <div class="hero-trust-item">
          <b>{{ currentLanguage === 'en' ? 'Trusted' : 'موثوقة' }}</b>
          <span>{{ currentLanguage === 'en' ? 'Jobs' : 'وظائف' }}</span>
        </div>

        <div class="hero-trust-item">
          <b>{{ currentLanguage === 'en' ? 'Fast' : 'سريع' }}</b>
          <span>{{ currentLanguage === 'en' ? 'Apply' : 'تقديم' }}</span>
        </div>
      </div>
    </div>

    <!-- Right Video Card -->
    <div class="hero-visual">
      <div class="hero-video-card">
        <div class="hero-video-topbar">
          <div class="hero-video-dots">
            <i></i>
            <i></i>
            <i></i>
          </div>

          <span>
            {{
              currentLanguage === 'en'
                ? 'AI Matching Preview'
                : 'معاينة المطابقة الذكية'
            }}
          </span>
        </div>

        <div class="hero-video-frame">
          <video
            class="hero-background-video"
            [src]="heroVideoSrc"
            autoplay
            muted
            [muted]="true"
            [volume]="0"
            loop
            playsinline
            preload="auto"
            aria-hidden="true"
            (loadedmetadata)="onHeroVideoReady($event)"
            (loadeddata)="onHeroVideoReady($event)"
            (canplay)="onHeroVideoReady($event)"
            (play)="muteVideo($event)"
            (volumechange)="muteVideo($event)"
            (error)="onHeroVideoError($event)"
          ></video>

          <div class="hero-video-overlay"></div>
          <div class="hero-video-shine"></div>
        </div>

        <div class="hero-video-footer">
          <div>
            <strong>
              {{ currentLanguage === 'en' ? 'CV Uploaded' : 'تم رفع السيرة' }}
            </strong>
            <small>
              {{
                currentLanguage === 'en'
                  ? 'Skills are being scanned'
                  : 'جاري تحليل المهارات'
              }}
            </small>
          </div>

          <span class="hero-video-status">
            {{ currentLanguage === 'en' ? 'Live' : 'نشط' }}
          </span>
        </div>

        <div class="hero-floating-card hero-floating-card-1">
          <span>01</span>
          <strong>
            {{ currentLanguage === 'en' ? 'CV Upload' : 'رفع السيرة' }}
          </strong>
        </div>

        <div class="hero-floating-card hero-floating-card-2">
          <span>02</span>
          <strong>
            {{ currentLanguage === 'en' ? 'AI Scan' : 'تحليل ذكي' }}
          </strong>
        </div>

        <div class="hero-floating-card hero-floating-card-3">
          <span>03</span>
          <strong>
            {{ currentLanguage === 'en' ? 'Job Match' : 'مطابقة وظيفة' }}
          </strong>
        </div>
      </div>
    </div>
  </section>
</main>